/* eslint-disable import/prefer-default-export */
import { t } from "i18next";

/**
 * Translate a message using i18next
 * @param {string} message - The message to translate
 * @returns {Promise<string>} - The translated message
 */

export function translate(message) {
	try {
		const json = JSON.parse(message);
		const text = json.message;
		const inputs = json.inputs || {};
		const translatedText = t(text, inputs);
		return translatedText;
	} catch (error) {
		return t(message);
	}
}
